import { DebitNoteRepository } from "../repositories/DebitNoteRepository";
import {
  DebitNoteListStatus,
  DebitNotesResultEntity,
} from "../entities/DebitNoteEntity";

/**
 * Get All Debit Notes Use Case
 * Retrieves debit notes through the unified list endpoint.
 */
export class GetAllDebitNotesUseCase {
  constructor(private repository: DebitNoteRepository) {}

  async execute(params?: {
    limit?: number;
    offset?: number;
    status?: DebitNoteListStatus;
    search?: string;
    date_from?: string;
    date_to?: string;
    sort_by?: "created_at" | "updated_at" | "document_number" | "status";
    sort_order?: "asc" | "desc";
  }): Promise<DebitNotesResultEntity> {
    if (params?.limit !== undefined && (params.limit < 1 || params.limit > 100)) {
      throw new Error("Limit must be between 1 and 100");
    }

    return await this.repository.fetchDebitNotes(params);
  }
}
